<div class="release-page">
  <div class="grain" aria-hidden="true"></div>

  <div class="container">
    <br /><br /><br />
    <br /><br />

    <h1 class="visually-hidden">{{ songTitle }} - {{ artistName }}</h1>

    <p class="presenter">ComeTralci Worship &middot; Nuova cover</p>

    <!-- Cover + player -->
    <div class="cover">
      <img
        *ngIf="!coverError"
        [src]="coverUrl"
        [alt]="'Copertina di ' + songTitle"
        (error)="coverError = true"
      />
      <div *ngIf="coverError" class="cover-placeholder">
        <span>{{ songTitle }}</span>
      </div>

      <div *ngIf="audioAvailable" class="preview-player">
        <audio
          #previewAudio
          [src]="previewAudioUrl"
          preload="metadata"
          (timeupdate)="onAudioTimeUpdate()"
          (ended)="onAudioEnded()"
          (error)="onAudioError()"
        ></audio>

        <button
          class="play-button"
          (click)="togglePlay()"
          [attr.aria-label]="isPlaying ? 'Pausa' : 'Ascolta l\'anteprima'"
        >
          <svg
            *ngIf="!isPlaying"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
          <svg
            *ngIf="isPlaying"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
          </svg>
        </button>

        <div class="player-center">
          <span class="player-label">anteprima</span>
          <div class="progress-bar" (click)="seekAudio($event)">
            <div class="progress-fill" [style.width.%]="audioProgress"></div>
          </div>
        </div>

        <span class="player-time">{{ audioCurrentTime }}</span>
      </div>
    </div>

    <p class="released-banner">Fuori ora su YouTube</p>

    <!-- YouTube action button -->
    <a
      [href]="youtubeUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="youtube-button"
    >
      <div class="icon">
        <img src="/icons/youtube.svg" width="30" height="30" alt="" />
      </div>
      <div class="text">
        <span class="label">Guarda il video su YouTube</span>
        <span class="sublabel">Video live ufficiale &middot; ComeTralci Worship</span>
      </div>
      <div class="arrow">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
        </svg>
      </div>
    </a>

    <!-- Social (Solo YouTube) -->
    <div class="socials">
      <a
        [href]="youtubeUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link"
      >
        <img src="/icons/youtube.svg" width="20" height="20" alt="" />
        YouTube
      </a>
    </div>

    <!-- Footer -->
    <p class="footer-text">{{ artistName }}</p>
  </div>
</div>
